__webpack_require__.p = "//a.msstatic.com/huya/h5player/huya-video-player/2.4.15/";